export const Padlock10 = () => (
  <>
    <span className="t-sr-only">Padlock</span>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6273 5.92592V5.4074C11.6273 4.44476 11.2449 3.52155 10.5642 2.84086C9.88353 2.16018 8.96032 1.77777 7.99769 1.77777C7.03505 1.77777 6.11184 2.16018 5.43115 2.84086C4.75046 3.52155 4.36806 4.44476 4.36806 5.4074V5.92592H2.8125V12.6667C2.8125 13.0792 2.97639 13.4749 3.26811 13.7666C3.55984 14.0583 3.9555 14.2222 4.36806 14.2222H11.6273C12.0399 14.2222 12.4355 14.0583 12.7273 13.7666C13.019 13.4749 13.1829 13.0792 13.1829 12.6667V5.92592H11.6273ZM5.40509 5.4074C5.40509 4.7198 5.67824 4.06037 6.16445 3.57416C6.65065 3.08796 7.31009 2.81481 7.99769 2.81481C8.68528 2.81481 9.34472 3.08796 9.83093 3.57416C10.3171 4.06037 10.5903 4.7198 10.5903 5.4074V5.92592H5.40509V5.4074ZM12.1458 12.6667C12.1458 12.8042 12.0912 12.9361 11.994 13.0333C11.8967 13.1305 11.7648 13.1852 11.6273 13.1852H4.36806C4.23054 13.1852 4.09865 13.1305 4.00141 13.0333C3.90417 12.9361 3.84954 12.8042 3.84954 12.6667V6.96296H12.1458V12.6667Z"
        fill="currentColor"
      />
      <path
        d="M8.51555 9.03705H7.47852V11.1111H8.51555V9.03705Z"
        fill="currentColor"
      />
    </svg>
  </>
);
